import React, {useEffect, useState} from "react";

import {Money} from "api-client";
import {useAppDispatch, useErrorCallback} from "hooks";
import {cn} from "utils";
import {createMyMoneyProvider, createProfileManager} from "di";
import {Balance, PlannedIndicators, PortfolioStatistics, UpcomingReceipts} from "components/pages";
import {Container, Loader, Money as MoneyComponent, Section} from "components";
import DonutChart from "components/pages/my-money/DonutChart";
import {set as setMoneyData} from "store/my-money";
import {set as setProfile} from "store/profile";

import styles from './MyMoney.module.scss';
import {useMyMoneyData} from "../../../../../hooks/useMyMoneyData";

const MyMoney = () => {
  const [loading, setLoading] = useState(true);
  const handleError = useErrorCallback();
  const dispatch = useAppDispatch();
  const {projectSummaryStats} = useMyMoneyData();

  useEffect(() => {
    loadMyMoneyData();
  }, []);

  const loadMyMoneyData = async () => {
    setLoading(true);
    try {
      await initMyMoneyData();
    } catch (error) {
      if (error instanceof Error) {
        await handleError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const initMyMoneyData = async () => {
    const statsProvider = await createMyMoneyProvider();
    const myMoneyData = await statsProvider.get();
    dispatch(setMoneyData(myMoneyData));

    const manager = await createProfileManager();
    const profile = await manager.get();
    dispatch(setProfile(profile));
  };

  let nowProjectsAtPlatform = 0;
  let nowSumAtPlatform = new Money(0, 'RUB');

  if (
    projectSummaryStats?.fundraisingSummary?.projectSum?.amount &&
      projectSummaryStats?.loanPaymentSummary?.projectSum?.amount
  ) {
    nowProjectsAtPlatform =
        (projectSummaryStats?.fundraisingSummary?.projectCount || 0) +
        (projectSummaryStats?.loanPaymentSummary?.projectCount || 0);
    nowSumAtPlatform = new Money(
      (projectSummaryStats?.fundraisingSummary?.projectSum?.amount || 0) +
        (projectSummaryStats?.loanPaymentSummary?.projectSum?.amount || 0),
      projectSummaryStats?.loanPaymentSummary?.projectSum?.currencyCode || 'RUB'
    );
  }

  const getLoanWord = (count: number) => {
    if (count % 10 === 1 && count % 100 !== 11) return "займ";
    if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) return "займа";
    return "займов";
  };

  return (
    <>
      <Container>
        {loading? <Loader/>:
          <Section>
            <div className={styles.myMoney__grid}>
              <div className={cn(styles.myMoney__balance, styles.myMoney__block)}><Balance/></div>
              <div className={cn(styles.myMoney__average, styles.myMoney__block)}><PlannedIndicators/></div>
              <div className={cn(styles.myMoney__totalFunds, styles.myMoney__block)}><DonutChart/></div>
              <div className={cn(styles.myMoney__upcomingPayments, styles.myMoney__block)}><UpcomingReceipts/></div>
              <div className={cn(styles.myMoney__currentDeals, styles.myMoney__block)}>
                <div>Сейчас сделок на платформе</div>
                <div className={styles.myMoney__currentDeals__sumTitle}>
                  <p><span>{nowProjectsAtPlatform}</span>{" "}
                    {getLoanWord(nowProjectsAtPlatform)}
                  </p>
                  <p> на сумму</p>
                </div>
                <div className={styles.myMoney__currentDeals__sum}>
                  <MoneyComponent money={nowSumAtPlatform}/>
                </div>
              </div>
              <div className={cn(styles.myMoney__underReview, styles.myMoney__block)}>
                <div>Находятся на рассмотрении</div>
                <div className={styles.myMoney__underReview__sumTitle}>
                  <p>
                    <span>{projectSummaryStats?.reviewSummary?.projectCount || 0}</span>{" "}
                    {getLoanWord(projectSummaryStats?.reviewSummary?.projectCount || 0)}
                  </p>
                  <p> на сумму</p>
                </div>
                <div className={styles.myMoney__underReview__sum}>
                  <MoneyComponent
                    money={
                      projectSummaryStats?.reviewSummary?.projectSum?.amount
                        ? projectSummaryStats?.reviewSummary?.projectSum
                        : new Money(0, "RUB")
                    }
                  />
                </div>
              </div>
              <div className={cn(styles.myMoney__portfolioStats, styles.myMoney__block)}><PortfolioStatistics/></div>
              {/*<div className={cn(styles.myMoney__faq, styles.myMoney__block)}>FAQ</div>*/}
            </div>
          </Section>}
      </Container>
    </>
  );
};

export default MyMoney;


